/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
} from '@one-thd/sui-atomic-components';
import {
  Card,
  CardHeader,
  CardItems,
} from './styles';

function FlooringCard(props) {
  const {
    title,
    children,
    testId,
  } = props;

  return (
    <div className="accordion-card" data-testid={testId}>
      <div className="sui-paper" style={{ paddingBottom: '2rem', borderTop: '0.1rem solid  #f5f5f5' }}>
        {title !== null ? (
          <div className="card-header">
            <Typography variant="h2">{title}</Typography>
          </div>
        )
          : null}
        <div className="card-items">
          <Typography> {children} </Typography>
        </div>
      </div>
    </div>
  );
}

FlooringCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string.isRequired,
};
FlooringCard.defaultProps = {
  title: 'Card Title',
};

export default FlooringCard;
